import { render, staticRenderFns } from "./CupomDescontoBuscaClientes.vue?vue&type=template&id=6b3a95be&scoped=true&"
import script from "./CupomDescontoBuscaClientes.vue?vue&type=script&lang=js&"
export * from "./CupomDescontoBuscaClientes.vue?vue&type=script&lang=js&"
import style0 from "./CupomDescontoBuscaClientes.vue?vue&type=style&index=0&id=6b3a95be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3a95be",
  null
  
)

export default component.exports